import { useQuery } from "@tanstack/react-query";
import { Axios } from "../../../Axios";
import NotaSituacao from "../../../../Models/Financeiro/Titulo/Nota/NotaSituacao";
import RequestUtilitario, { QueryBasicaParam } from "../../../../Utils/RequisicaoUtilitario";
import { AxiosResponse } from "axios";

export function useNotaSituacaoListar({
    notaSitucao,
    ativo,
    ...rest
}:QueryBasicaParam<AxiosResponse<NotaSituacao[]>, NotaSituacao[], {
    notaSitucao?:NotaSituacao,
    ativo?:boolean
}>) {
    const queryString = RequestUtilitario.objectToQueryString({
        ...(notaSitucao ?? {}),
        ativo
    });

    return useQuery({
        ...rest,
        queryKey : ["Financeiro.Titulo.Nota.NotaSituacao.Listar", `Financeiro.Titulo.Nota.NotaSituacao.Listar?${queryString}`],
        queryFn : () => Axios.get<NotaSituacao[]>(`financeiro/titulo/nota/notaSituacao?${queryString}`),
        select(response) {
            return response.data.map(m => m);
        },
        staleTime : 1000 * 60 * 10 // 10 minutos
    });
}